import moment from 'moment'
import { SMOOTH_INTERVAL } from '../constants'

const CUSTOM_TIME_RANGE = 'custom'
const DEFAULT_TIME_RANGE = '24h'

// presets roll forward with each poll; custom stays fixed on the picked dates
const TIME_RANGES = [
  { value: '1h', label: 'Last Hour', duration: { hours: 1 } },
  { value: '6h', label: 'Last 6 Hours', duration: { hours: 6 } },
  { value: '12h', label: 'Last 12 Hours', duration: { hours: 12 } },
  { value: '24h', label: 'Last 24 Hours', duration: { hours: 24 } },
  { value: '1w', label: 'Last Week', duration: { weeks: 1 } },
  { value: '1mo', label: 'Last Month', duration: { months: 1 } },
  { value: CUSTOM_TIME_RANGE, label: 'Custom' },
]

const getPresetWindow = timeRange => {
  const { duration } = TIME_RANGES.find(x => x.value === timeRange)
  const endValue = moment()

  return { startValue: moment(endValue).subtract(duration), endValue }
}

// the window a poll or filter change should load: presets move up to now,
// custom keeps the picked dates
const getCurrentWindow = ({ timeRange, startValue, endValue }) =>
  timeRange === CUSTOM_TIME_RANGE
    ? { startValue, endValue }
    : getPresetWindow(timeRange)

// reads the range from the URL. links from before the time range option only
// carry start/end times, so those are treated as a custom range
const getTimeRangeFromParams = ({ range, startTime, endTime }) => {
  const hasCustomWindow = !!(startTime && endTime)
  const timeRange = TIME_RANGES.some(x => x.value === range)
    ? range
    : hasCustomWindow
    ? CUSTOM_TIME_RANGE
    : DEFAULT_TIME_RANGE

  if (timeRange === CUSTOM_TIME_RANGE && hasCustomWindow) {
    return {
      timeRange,
      startValue: moment(startTime * 1000),
      endValue: moment(endTime * 1000),
    }
  }

  return {
    timeRange,
    ...getPresetWindow(
      timeRange === CUSTOM_TIME_RANGE ? DEFAULT_TIME_RANGE : timeRange
    ),
  }
}

// presets store only the range so a shared link stays live; custom stores the
// exact window
const getTimeRangeParams = ({ timeRange, startValue, endValue }) => {
  const isCustom = timeRange === CUSTOM_TIME_RANGE

  return {
    range: timeRange,
    startTime: isCustom ? startValue.unix() : undefined,
    endTime: isCustom ? endValue.unix() : undefined,
  }
}

const getSmoothQuery = smoothInterval => ({
  smooth: smoothInterval === SMOOTH_INTERVAL.RAW ? 'f' : 't',
  smoothInterval:
    smoothInterval !== SMOOTH_INTERVAL.RAW ? smoothInterval : undefined,
})

export {
  CUSTOM_TIME_RANGE,
  DEFAULT_TIME_RANGE,
  TIME_RANGES,
  getPresetWindow,
  getCurrentWindow,
  getTimeRangeFromParams,
  getTimeRangeParams,
  getSmoothQuery,
}
